<div class="accordion-container">
  <div class="content">
    <div class="item" *ngFor="let item of accordionItems">
      <kion-accordion-list-item [item]="item" [open]="isOpen(item)" (toggle)="toggle($event)"></kion-accordion-list-item>
    </div>
  </div>
</div>
